import { render, staticRenderFns } from "./addlist.vue?vue&type=template&id=5505e973&scoped=true&"
import script from "./addlist.vue?vue&type=script&lang=js&"
export * from "./addlist.vue?vue&type=script&lang=js&"
import style0 from "./addlist.vue?vue&type=style&index=0&id=5505e973&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505e973",
  null
  
)

export default component.exports